import styled from 'styled-components';

/**
 * Text that is available to assistive technology but not painted.
 *
 * Use it to name a control whose visible content cannot serve as its label — an
 * icon-only button, or one whose visible text is a glyph like `×`. Give it an
 * `id` and point the control's `aria-labelledby` at it:
 *
 *     const labelId = useId();
 *     <Button aria-labelledby={labelId}>
 *         <SomeIcon />
 *         <VisuallyHidden id={labelId}>Dismiss</VisuallyHidden>
 *     </Button>
 *
 * `aria-labelledby` is required rather than `aria-label` because the
 * design-system Button derives its own `aria-label` from its children and
 * applies it after the caller's props, discarding anything passed in.
 * `aria-labelledby` outranks `aria-label` in the accessible-name algorithm, so
 * it is the only way to give one of those buttons a meaningful name.
 */
export const VisuallyHidden = styled.span`
	position: absolute;
	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
`;
